import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'da',
  months: [
    'januar',
    'februar',
    'marts',
    'april',
    'maj',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'december',
  ],
  monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'juni', 'juli', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
  weekdays: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
  weekdaysMin: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  weekdaysShort: ['søn.', 'man.', 'tirs.', 'ons.', 'tors.', 'fre.', 'lør.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'D.M.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY [kl.] HH:mm',
    'LLL-Y': 'D. MMMM [kl.] HH:mm',
    LLLL: 'dddd, D. MMMM YYYY [kl.] HH:mm',
    'LLLL-Y': 'dddd, D. MMMM [kl.] HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    'll-D': 'MMM YYYY',
    lll: 'D. MMM YYYY HH:mm',
    'lll-Y': 'D. MMM HH:mm',
    llll: 'ddd D. MMM YYYY HH:mm',
    'llll-Y': 'ddd D. MMM HH:mm',
    'll-Y+w': 'ddd D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'fm', pm: 'em', AM: 'FM', PM: 'EM' },
  past: {
    y: { one: '%s år siden', other: '%s år siden' },
    M: { one: '%s md. siden', other: '%s mdr. siden' },
    w: { one: '%s uge siden', other: '%s uger siden' },
    d: { one: '%s dag siden', other: '%s dage siden' },
    h: { one: '%s time siden', other: '%s timer siden' },
    m: { one: '%s min. siden', other: '%s min. siden' },
    s: { one: '%s sek. siden', other: '%s sek. siden' },
  },
  future: {
    y: { one: 'om %s år', other: 'om %s år' },
    M: { one: 'om %s md.', other: 'om %s mdr.' },
    w: { one: 'om %s uge', other: 'om %s uger' },
    d: { one: 'om %s dag', other: 'om %s dage' },
    h: { one: 'om %s time', other: 'om %s timer' },
    m: { one: 'om %s min.', other: 'om %s min.' },
    s: { one: 'om %s sek.', other: 'om %s sek.' },
  },
  pastLong: {
    y: { one: 'for %s år siden', other: 'for %s år siden' },
    M: { one: 'for %s måned siden', other: 'for %s måneder siden' },
    w: { one: 'for %s uge siden', other: 'for %s uger siden' },
    d: { one: 'for %s dag siden', other: 'for %s dage siden' },
    h: { one: 'for %s time siden', other: 'for %s timer siden' },
    m: { one: 'for %s minut siden', other: 'for %s minutter siden' },
    s: { one: 'for %s sekund siden', other: 'for %s sekunder siden' },
  },
  futureLong: {
    y: { one: 'om %s år', other: 'om %s år' },
    M: { one: 'om %s måned', other: 'om %s måneder' },
    w: { one: 'om %s uge', other: 'om %s uger' },
    d: { one: 'om %s dag', other: 'om %s dage' },
    h: { one: 'om %s time', other: 'om %s timer' },
    m: { one: 'om %s minut', other: 'om %s minutter' },
    s: { one: 'om %s sekund', other: 'om %s sekunder' },
  },
  abbr: {
    y: { one: '%s år', other: '%s år' },
    M: { one: '%s md.', other: '%s mdr.' },
    w: { one: '%s u.', other: '%s u.' },
    d: { one: '%s d.', other: '%s d.' },
    h: { one: '%s t.', other: '%s t.' },
    m: { one: '%s min.', other: '%s min.' },
    s: { one: '%s sek.', other: '%s sek.' },
  },
  full: {
    y: { one: '%s år', other: '%s år' },
    M: { one: '%s måned', other: '%s måneder' },
    w: { one: '%s uge', other: '%s uger' },
    d: { one: '%s dag', other: '%s dage' },
    h: { one: '%s time', other: '%s timer' },
    m: { one: '%s minut', other: '%s minutter' },
    s: { one: '%s sekund', other: '%s sekunder' },
  },
  justNow: 'Lige nu',
  yesterday: 'I går',
  today: 'I dag',
  tomorrow: 'I morgen',
  weekStart: 1,
  timeRange: '%$1s-%$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D. MMMM YYYY', end: 'D. MMMM YYYY' },
    'yl-1': { start: 'D. MMMM', end: 'D. MMMM YYYY' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'D.', end: 'D. MMMM YYYY' },
    dl: { start: 'D.', end: 'D. MMMM' },
    y: { start: 'D. MMM YYYY', end: 'D. MMM YYYY' },
    'y-1': { start: 'D. MMM', end: 'D. MMM YYYY' },
    m: { start: 'D. MMM', end: 'D. MMM' },
    'm-1': { start: 'D.', end: 'D. MMM YYYY' },
    d: { start: 'D.', end: 'D. MMM' },
    Y: { start: 'ddd, D. MMM YYYY', end: 'ddd, D. MMM YYYY' },
    'Y-1': { start: 'ddd, D. MMM', end: 'ddd, D. MMM YYYY' },
    M: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    D: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    yt: { start: 'D. MMM YYYY HH:mm', end: 'D. MMM YYYY HH:mm' },
    mt: { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm' },
    dt: { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D. MMM YYYY HH:mm', end: 'D. MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'da';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'fm' : 'FM';
    } else {
      return isLowerCase ? 'em' : 'EM';
    }
  },
};
